import * as t from "io-ts";
import { Category } from "./Category";

export const Quiz = t.intersection([
  t.type({
    category: Category,
    question: t.string,
    answers: t.array(t.string),
  }),
  t.partial({
    videoId: t.string,
    user_answer: t.string,
    correct_answer: t.string,
  }),
]);

export interface Quiz {
  category: Category;
  question: string;
  videoId?: string;
  answers: Array<string>;
  user_answer?: string;
  correct_answer?: string;
}
